import * as angular from "angular";
import {PoliciesService} from "../../policies/services/policies-service.service";
import * as _ from "lodash";
import {PoliciesAlertsService} from "../../policies/services/policies-alerts.service";

export class RolesGroupsDialogsService {

  /* @ngInject */
  constructor(private $mdDialog, private policiesService: PoliciesService, private policiesAlertsService: PoliciesAlertsService) {}

  createGroup(event, roleOptions) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true,
      template: require('../views/dialogs/create-roles-group-dialog.html').default,
      controller: function ($scope) {

        $scope.cancel = self.$mdDialog.cancel;
        $scope.isCreate = true;

        const roleOptionsCopy = angular.copy(roleOptions);
        const roles = self.policiesService.getRolesWithPermissionsByVersion(roleOptionsCopy);

        $scope.selectedRoles = [];
        $scope.rolesMap = self.policiesService.translateRolesMap(self.policiesService.getRoleMap(roles));

        $scope.userRoles = [];

        $scope.group = {
          name: undefined,
          roleIds: [],
          rolesGroupTagName: []
        };

        $scope.onTagsChange = (tagNames) => {
          $scope.group.rolesGroupTagName = tagNames;
        }

        $scope.onChangeRoles = (updatedRoles) => {
          $scope.selectedRoles = updatedRoles;
          $scope.group.roleIds = _.map(updatedRoles, 'id');
        }

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              if ($scope.group.roleIds.length) {
                self.$mdDialog.hide($scope.group);
              } else {
                self.policiesAlertsService.invalidRoleSelectionInfo();
              }
            }
          }
        }
      }
    })
  }

  editGroup(event, group, roleOptions) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true,
      template: require('../views/dialogs/create-roles-group-dialog.html').default,
      controller: function ($scope) {

        $scope.cancel = self.$mdDialog.cancel;
        $scope.isCreate = false;

        $scope.group = angular.copy(group);

        // $scope.group = {
        //   roleIds: _.map($scope.selectedRoles, 'id'),
        //   name: group.name
        // };

        const roleOptionsCopy = angular.copy(roleOptions);
        const roles = self.policiesService.getRolesWithPermissionsByVersion(roleOptionsCopy);

        $scope.rolesMap = self.policiesService.translateRolesMap(self.policiesService.getRoleMap(roles));
        $scope.selectedRoleIds = angular.copy(group.roleIds);

        $scope.selectedRoles = roleOptions.filter((r) => {
          return _.includes($scope.selectedRoleIds, r.id)
        })

        $scope.onTagsChange = (tagNames) => {
          $scope.group.rolesGroupTagName = tagNames;
        }

        $scope.onChangeRoles = (updatedRoles) => {
          $scope.selectedRoles = updatedRoles;
          $scope.group.roleIds = _.map(updatedRoles, 'id');
        }

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              if ($scope.group.roleIds.length) {
                self.$mdDialog.hide($scope.group);
              } else {
                self.policiesAlertsService.invalidRoleSelectionInfo();
              }
            }
          }
        }


      }
    })
  }

  addUsers(userOptions, connectedUserIds, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true,
      template: require('../views/dialogs/add-remove-users-group-dialog.html').default,
      controller: function ($scope, $mdSelect) {
        $scope.isAdd = true;
        $scope.users = [];
        $scope.userOptions = angular.copy(userOptions);

        $scope.excludedMap = {};
        _.forEach(connectedUserIds, (id) => {
          $scope.excludedMap[id] = true;
        })
        $scope.cancel = self.$mdDialog.cancel;


        $scope.onUsersChange = (users) => {
          $scope.users = users;
        }

        $scope.reset = () => {
          $scope.users = [];
          $mdSelect.hide();
        }

        $scope.select = () => {
          $mdSelect.hide();
        }

        $scope.onSubmit = () => {
          const connectedUserIds = _.map($scope.users, 'id');
          self.$mdDialog.hide(connectedUserIds);
        }
      }
    })
  }

  removeUsers(userOptions, connectedUserIds, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true,
      template: require('../views/dialogs/add-remove-users-group-dialog.html').default,
      controller: function ($scope, $mdSelect) {
        $scope.users = [];
        $scope.userOptions = _.filter(userOptions, (u) => {
          return _.includes(connectedUserIds, u.id);
        });
        $scope.cancel = self.$mdDialog.cancel;

        $scope.onUsersChange = (users) => {
          $scope.users = users;
        }

        $scope.reset = () => {
          $scope.users = [];
          $mdSelect.hide();
        }

        $scope.select = () => {
          $mdSelect.hide();
        }

        $scope.onSubmit = () => {
          const connectedUserIds = _.map($scope.users, 'id');
          self.$mdDialog.hide(connectedUserIds);
        }
      }
    })
  }


}

angular
  .module('bringoz.admin.site-preferences')
  .service('rolesGroupsDialogsService', RolesGroupsDialogsService);
